import React from "react";
import ReactDOM from "react-dom/client";
// Sentry must be imported BEFORE React so global handlers attach early.
// No-op when REACT_APP_SENTRY_DSN is empty — safe for preview/tests.
import { Sentry, SENTRY_ENABLED } from "@/sentry";
import "@/index.css";
import App from "@/App";

const container = document.getElementById("root");
const rootOpts = SENTRY_ENABLED
  ? {
      onUncaughtError: Sentry.reactErrorHandler(),
      onCaughtError: Sentry.reactErrorHandler(),
      onRecoverableError: Sentry.reactErrorHandler(),
    }
  : undefined;
const root = ReactDOM.createRoot(container, rootOpts);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);

// ── Service Worker registration ───────────────────────────────────────────────
// Only in production builds to avoid stale-cache confusion during development.
if ('serviceWorker' in navigator && process.env.NODE_ENV === 'production') {
  window.addEventListener('load', () => {
    navigator.serviceWorker
      .register('/sw.js', { scope: '/' })
      .then((registration) => {
        // Notify existing SW to activate immediately when a new version is detected
        registration.addEventListener('updatefound', () => {
          const newWorker = registration.installing;
          if (newWorker) {
            newWorker.addEventListener('statechange', () => {
              if (newWorker.state === 'installed' && navigator.serviceWorker.controller) {
                newWorker.postMessage({ type: 'SKIP_WAITING' });
              }
            });
          }
        });
      })
      .catch((err) => console.warn('SW registration failed:', err));
  });
}
